import { useState } from "react";
import { Tabs } from "antd";
import { LeftOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import BasicInfoTab from "./users/BasicInfoTab";
import ZoneMappingTab from "./users/ZoneMappingTab";
import AccessControlTab from "./users/AccessControlTab";
import SecurityPasswordsTab from "./users/SecurityPasswordsTab";
import LeaveTab from "./leaves/LeaveTab";
import "./UsersLeaves.css";

const SECTIONS = {
  USERS: "users",
  LEAVES: "leaves",
};

const USER_TABS = [
  { key: "basic-info", label: "Basic Info" },
  { key: "zone-mapping", label: "Zone Mapping" },
  { key: "access-control", label: "Access Control" },
  { key: "security", label: "Security & Passwords" },
];

const LEAVE_TABS = [
  { key: "pending-leaves", label: "Pending Leaves" },
  { key: "approved-leaves", label: "Approved Leaves" },
  { key: "rejected-leaves", label: "Rejected Leaves" },
];

export default function UsersLeaves() {
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState(SECTIONS.USERS);
  const [activeTab, setActiveTab] = useState("basic-info");

  const handleSectionChange = (section) => {
    setActiveSection(section);
    setActiveTab(section === SECTIONS.USERS ? "basic-info" : "pending-leaves");
  };

  const tabs = activeSection === SECTIONS.USERS ? USER_TABS : LEAVE_TABS;

  const renderTabContent = () => {
    if (activeSection === SECTIONS.USERS) {
      switch (activeTab) {
        case "basic-info":
          return <BasicInfoTab />;
        case "zone-mapping":
          return <ZoneMappingTab />;
        case "access-control":
          return <AccessControlTab />;
        case "security":
          return <SecurityPasswordsTab />;
        default:
          return null;
      }
    }

    switch (activeTab) {
      case "pending-leaves":
        return <LeaveTab status="pending" />;
      case "approved-leaves":
        return <LeaveTab status="approved" />;
      case "rejected-leaves":
        return <LeaveTab status="rejected" />;
      default:
        return null;
    }
  };

  return (
    <div>
      <div className="dual-banner">
        <button
          type="button"
          className="banner-back"
          onClick={() => navigate("/dashboard")}
          aria-label="Back"
        >
          <LeftOutlined />
        </button>
        <div
          className={`banner-half ${activeSection === SECTIONS.USERS ? "on" : "off"}`}
          onClick={() => handleSectionChange(SECTIONS.USERS)}
        >
          <span className="banner-text">USERS SETUP</span>
        </div>
        <div
          className={`banner-half ${activeSection === SECTIONS.LEAVES ? "on" : "off"}`}
          onClick={() => handleSectionChange(SECTIONS.LEAVES)}
        >
          <span className="banner-text">LEAVE MANAGEMENT</span>
        </div>
      </div>

      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        items={tabs}
        className="users-leaves-tabs"
      />

      <div className="users-leaves-content">
        {renderTabContent()}
      </div>
    </div>
  );
}
